document.addEventListener('DOMContentLoaded', function () {
  const stickyContainer = document.querySelector('.sticky-add-to-cart-button-head');
  const stickyBtn = stickyContainer.querySelector('.sticky-atc-btn');
  const mainAtcBtn = document.querySelector('form .product-form__submit'); // Main Add to Cart button
  const cartDrawer = document.querySelector('#cart-drawer'); // Check your theme for the correct selector

  function toggleStickyButton() {
    if (!mainAtcBtn) return;

    const rect = mainAtcBtn.getBoundingClientRect();
    if (rect.top < 0 || rect.bottom < 0) {
      stickyContainer.classList.add('visible');
    } else {
      stickyContainer.classList.remove('visible');
    }
  }

  // Detect when the cart drawer opens
  function hideStickyButtonOnDrawer() {
    if (!cartDrawer) return;

    const observer = new MutationObserver(() => {
      if (cartDrawer.classList.contains('is-open')) {
        stickyContainer.classList.remove('visible'); // Hide when cart drawer opens
      } else {
        toggleStickyButton(); // Show again when drawer closes
      }
    });

    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  // Add click event to trigger Add to Cart with loading effect
  stickyBtn.addEventListener('click', function () {
    if (mainAtcBtn) {
      stickyBtn.classList.add('loading'); // Show spinner
      mainAtcBtn.click(); // Simulate click on main button

      setTimeout(() => {
        stickyBtn.classList.remove('loading'); // Remove spinner after 1.5s
      }, 1500);
    }
  });

  // Scroll event listener
  window.addEventListener('scroll', toggleStickyButton);

  // Detect cart drawer opening
  hideStickyButtonOnDrawer();
});
